module.exports = __webpack_public_path__ + "static/media/logo.0861fdc2.png";